import React from 'react';
import styled from 'styled-components';
import VerticalBarChart from '../comp/VerticalBarChart'; // Assume this component exists
import KPISection from './KPISection';
import { coresGrafico } from '../../../../styles/styleUtils';

const ChartsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; // Two equal columns
  gap: 30px;

  @media (max-width: 992px) {
    // Stack charts below 992px
    grid-template-columns: 1fr;
  }
`;
const options = {
  chart: { id: 'vendas-realizadas', toolbar: { show: false } },
  xaxis: { categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  colors: coresGrafico,
  plotOptions: { bar: { columnWidth: '60%', borderRadius: 4 } },
  dataLabels: {
    enabled: false,
    formatter: (val) => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    style: { fontSize: '11px' },
  },
  tooltip: {
    y: {
      formatter: (val) => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    },
  },
  legend: { position: 'top', horizontalAlign: 'right' },
};

const ChartsSection2 = ({ kpis, data, filtro }) => {
  const seriesVenda = [
    { name: 'Meta', data: data.MetaVenda },
    { name: 'Realizado', data: data.RealizadoVenda },
  ];
  return (
    <ChartsContainer>
      <div>
        <VerticalBarChart
          chartId="vendas-realizadas-chart"
          title="Meta de Vendas"
          options={options}
          series={seriesVenda}
          type="bar"
          height={350}
        />
      </div>
      <KPISection kpis={kpis} data={data} filtro={filtro}/>
    </ChartsContainer>
  );
};

export default ChartsSection2;
